import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FadeUp } from "@/components/motion/Reveal";

const faqs = [
  {
    q: "Can I really refinance my life insurance?",
    a: "Yes — just like a mortgage or car loan, you can switch your life insurance policy for a better rate at any time. Rates change, your health may have improved, and new insurers keep entering the market. Many Advanced Life Policies members save 20–40% and often walk away with more coverage than they had before.",
  },
  {
    q: "Do you help with taxes and financial planning too?",
    a: "Yes. Alongside life insurance, Advanced Life Policies advisors help clients with proactive tax planning and broader financial consulting — retirement, college savings, cash-flow clean-up, and second opinions on existing plans. Same trusted team, one relationship, no cross-selling.",
  },
  {
    q: "Is the quote really free?",
    a: "Completely. The savings estimator gives you a real price instantly, before you share any personal details. No cost, no obligation, no surprise calls.",
  },
  {
    q: "Will I have a gap in coverage when I switch?",
    a: "No. Advanced Life Policies only cancels your old policy after the new one is fully in force, so you're never uncovered — not even for a day.",
  },
  {
    q: "Do I need a medical exam?",
    a: "For most applicants, no exam is required — just a few health questions. Higher coverage amounts may occasionally need one, and Advanced Life Policies will let you know upfront.",
  },
  {
    q: "How are you able to save me money?",
    a: "We use technology instead of expensive call centres and compare rates across trusted insurers, then pass the savings straight to you. Members save an average of 22%.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-sand py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <FadeUp className="text-center">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-sage">Good questions</span>
          <h2 className="mt-4 font-serif font-light text-forest text-4xl sm:text-5xl lg:text-6xl leading-[0.98] tracking-tight">
            Everything you&apos;re wondering
          </h2>
        </FadeUp>

        <FadeUp delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-forest/15" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-serif text-xl lg:text-2xl text-forest hover:no-underline hover:text-terracotta py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-forest/70 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
}
